//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    show: Boolean
  },
  data() {
    return {
      imgLogo: require("@/assets/image/icon/logo_2.png")
    };
  },
  methods: {
    openApps() {
      if (this.isMobile) {
        this.OPENAPP();
      } else {
        window.location.href = "http://nowbook.hk/#/download";
      }
      // this.OPENAPP();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/FooterBtn.vue